import { Link } from "react-router-dom";
import { ArrowLeft, EnvelopeSimple } from "@phosphor-icons/react";
import { OPERO_LOGOS } from "@opero/ui/brand";

export function PressPage() {
  return (
    <main className="pt-28 pb-20">
      <div className="mx-auto max-w-3xl px-6">
        <Link
          to="/"
          className="inline-flex items-center gap-2 text-sm font-medium text-slate-500 dark:text-slate-400 hover:text-primary-500 dark:hover:text-primary-400 transition-colors"
        >
          <ArrowLeft size={16} />
          Back to Home
        </Link>

        <h1 className="mt-8 text-3xl font-bold tracking-tight text-slate-900 dark:text-white sm:text-4xl">
          Press & Media
        </h1>
        <p className="mt-3 text-lg text-slate-600 dark:text-slate-300">
          Brand assets, company information, and media contact details for press
          and editorial use.
        </p>

        {/* Brand Assets */}
        <section className="mt-12">
          <h2 className="text-xl font-bold text-slate-900 dark:text-white">
            Brand Assets
          </h2>
          <div className="mt-6 grid gap-6 sm:grid-cols-2">
            <div className="rounded-2xl border border-slate-200/60 dark:border-slate-800/60 bg-white dark:bg-slate-900 p-6">
              <div className="flex h-20 items-center justify-center rounded-xl bg-slate-50 dark:bg-slate-800">
                <img src={OPERO_LOGOS.mark} alt="Opero Mark" className="h-10" />
              </div>
              <h3 className="mt-4 text-sm font-semibold text-slate-900 dark:text-white">
                Logo Mark
              </h3>
              <p className="mt-1 text-xs text-slate-500 dark:text-slate-400">
                Use the mark in tight spaces where the full logo won't fit.
              </p>
            </div>
            <div className="rounded-2xl border border-slate-200/60 dark:border-slate-800/60 bg-white dark:bg-slate-900 p-6">
              <div className="flex h-20 items-center justify-center rounded-xl bg-slate-50 dark:bg-slate-800">
                <div className="flex items-center gap-2">
                  <img src={OPERO_LOGOS.mark} alt="Opero" className="h-8" />
                  <span className="text-xl font-bold text-slate-900 dark:text-white">
                    Opero
                  </span>
                </div>
              </div>
              <h3 className="mt-4 text-sm font-semibold text-slate-900 dark:text-white">
                Full Logo
              </h3>
              <p className="mt-1 text-xs text-slate-500 dark:text-slate-400">
                Preferred logo for most editorial and marketing use.
              </p>
            </div>
          </div>
        </section>

        {/* Company Facts */}
        <section className="mt-12">
          <h2 className="text-xl font-bold text-slate-900 dark:text-white">
            Company Facts
          </h2>
          <div className="mt-4 rounded-2xl border border-slate-200/60 dark:border-slate-800/60 bg-white dark:bg-slate-900 divide-y divide-slate-200/60 dark:divide-slate-800/60">
            {[
              ["Founded", "2025"],
              ["Headquarters", "Accra, Ghana"],
              ["Parent Company", "Digiits"],
              ["Product", "Task management platform with the Atlas AI assistant"],
              ["Website", "opero.io"],
            ].map(([label, value]) => (
              <div
                key={label}
                className="flex items-center justify-between px-6 py-3.5"
              >
                <span className="text-sm font-medium text-slate-500 dark:text-slate-400">
                  {label}
                </span>
                <span className="text-sm text-slate-900 dark:text-white">
                  {value}
                </span>
              </div>
            ))}
          </div>
        </section>

        {/* Media Contact */}
        <section className="mt-12">
          <h2 className="text-xl font-bold text-slate-900 dark:text-white">
            Media Contact
          </h2>
          <div className="mt-4 rounded-2xl border border-slate-200/60 dark:border-slate-800/60 bg-white dark:bg-slate-900 p-6">
            <p className="text-sm text-slate-600 dark:text-slate-300">
              For press inquiries, interviews, or partnership opportunities,
              reach out to our communications team.
            </p>
            <a
              href="mailto:corporate@digiits.com"
              className="mt-4 inline-flex items-center gap-2 text-sm font-medium text-primary-500 dark:text-primary-400 hover:underline"
            >
              <EnvelopeSimple size={16} />
              corporate@digiits.com
            </a>
          </div>
        </section>
      </div>
    </main>
  );
}
